import React from 'react';
import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ManualCodeSettings, QrSettings, RequirementSettings } from '@/components/surveyAccess/accessProfileFields';
import { AntiGamingSettings } from '@/components/surveyAccess/AntiGamingSettings';

// Phase 4B — the existing Phase 3 technical controls, collapsed by default.
export const AdvancedSettings = ({ form, set, open, onOpenChange, children }) => (
  <Collapsible open={open} onOpenChange={onOpenChange} className="rounded-lg border border-[#E2E8F0] bg-[#F8FAFC]" data-testid="access-advanced">
    <CollapsibleTrigger asChild>
      <button type="button" className="w-full flex items-center justify-between gap-3 px-3 py-2.5 text-left" data-testid="access-advanced-toggle">
        <span className="flex items-center gap-2">
          <SlidersHorizontal className="w-4 h-4 text-[#1A3E6F]" />
          <span>
            <span className="block text-xs font-bold text-[#0F172A]">Advanced Settings</span>
            <span className="block text-[11px] text-[#64748B]">Receipt / QR format for this client. Only change these if the POS or code format changes.</span>
          </span>
        </span>
        <ChevronDown className={`w-4 h-4 text-[#64748B] transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>
    </CollapsibleTrigger>
    <CollapsibleContent className="space-y-4 px-3 pb-3 bg-white rounded-b-lg pt-3 border-t border-[#E2E8F0]" data-testid="access-advanced-settings">
      <RequirementSettings form={form} set={set} />
      {(form.methods.manual || form.qr.code_param) && <ManualCodeSettings form={form} set={set} />}
      {form.methods.qr && <QrSettings form={form} set={set} />}
      <AntiGamingSettings form={form} set={set} />
      {children}
    </CollapsibleContent>
  </Collapsible>
);
